import axios from 'axios';

const VIACEP_BASE_URL = 'https://viacep.com.br/ws';

export default class ViaCepService {
    static async getAddressByPostalCode(postalCode) {
        const cep = String(postalCode || '').replace(/\D/g, '');
        if (cep.length !== 8) {
            return null;
        }
        try {
            const {data} = await axios.get(`${VIACEP_BASE_URL}/${cep}/json/`);
            if (!data || data.erro) {
                return null;
            }
            return data;
        } catch (err) {
            return null;
        }
    }
}
